// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2719C","inner":"Footer_inner__298oa","nextIcon":"Footer_nextIcon__2A8kq","innerLeft":"Footer_innerLeft__3lnWF"};